module.exports = __webpack_public_path__ + "static/media/paleta.2e93cc3b.jpeg";